@if (cars$ | async; as cars) {

  <h2 class="title" i18n>Переглянуті авто</h2>

  @if (isLoading()) {
    <evland-section-loader [height]="120"></evland-section-loader>
  } @else {
    <evland-car-list [cars]="cars" [hideToolbar]="true"></evland-car-list>
  }

}
